@if(field.hasControl) {
  @switch (field.type) {
    @case (_FrontendFieldType.groupBox) {
      <p-fieldset #componentFieldSet
        [class.ng-invalid]="errorMessage != null"
        [class.ng-dirty]="errorMessage != null"
        [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
        [tooltipStyleClass]="field.tooltipStyleClasses"
        [legend]="field.caption"
        [style.text-transform]="field.upperCase ? 'uppercase' : null"
        [style.position]="fixedPos ? 'absolute' : undefined"
        [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
        [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
        [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
        [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
        [style.z-index]="'-1'"
        styleClass="transparent"
        >
        <div
          [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
          [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
          >
        </div>
      </p-fieldset>
    }
    @case (_FrontendFieldType.string) {
      <input type="text" #componentInput pInputText
        [class.ng-invalid]="errorMessage != null"
        [class.ng-dirty]="errorMessage != null"
        [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
        [tooltipStyleClass]="field.tooltipStyleClasses"
        [maxLength]="field.maxLength ?? 255"
        [disabled]="!field.enabled"
        [attr.placeholder]="field.getPlaceholder()"
        [style.text-transform]="field.upperCase ? 'uppercase' : null"
        [style.position]="fixedPos ? 'absolute' : undefined"
        [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
        [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
        [style.width]="fixedPos ? field.fixedControlBounds.width + 'px' : '100%'"
        [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
        [(ngModel)]="field.value"
        (change)="valueChanged()"
        (keypress)="keyPress($event)"
        >
      }
      @case (_FrontendFieldType.password) {
        <p-password #componentPassword
          [class.ng-invalid]="errorMessage != null"
          [class.ng-dirty]="errorMessage != null"
          [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
          [tooltipStyleClass]="field.tooltipStyleClasses"
          [feedback]="field.passwordFeedback"
          [disabled]="!field.enabled"
          [placeholder]="field.getPlaceholder()"
          [toggleMask]="true"
          [style.text-transform]="field.upperCase ? 'uppercase' : null"
          [style.position]="fixedPos ? 'absolute' : undefined"
          [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
          [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
          [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
          [style]="{'width': fluentWidth ?? '100%'}"
          [inputStyle]="{'width': fluentWidth ?? '100%'}"
          [(ngModel)]="field.value"
          (change)="valueChanged()"
          (keypress)="keyPress($event)"
        ></p-password>
      }
      @case(_FrontendFieldType.int) {
        <p-inputNumber #componentInputNumber
          [class.ng-invalid]="errorMessage != null"
          [class.ng-dirty]="errorMessage != null"
          [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
          [tooltipStyleClass]="field.tooltipStyleClasses"
          [name]="field.id"
          [showButtons]="true"
          [format]="false"
          [attr.placeholder]="field.getPlaceholder()"
          [disabled]="!field.enabled"
          [step]="field.spinnerStep"
          [min]="field.minValue == null ? undefined : field.minValue"
          [max]="field.maxValue == null ? undefined : field.maxValue"
          [style.position]="fixedPos ? 'absolute' : undefined"
          [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
          [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
          [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
          [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
          [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 'px'} : undefined"
          [(ngModel)]="field.value"
          (ngModelChange)="valueChanged()"
          >
        </p-inputNumber>
      }
      @case(_FrontendFieldType.decimal) {
        <p-inputNumber #componentInputNumber
          [class.ng-invalid]="errorMessage != null"
          [class.ng-dirty]="errorMessage != null"
          [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
          [tooltipStyleClass]="field.tooltipStyleClasses"
          mode="decimal"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [name]="field.id"
          [showButtons]=true
          [attr.placeholder]="field.getPlaceholder()"
          [disabled]="!field.enabled"
          [step]="field.spinnerStep"
          [min]="field.minValue == null ? undefined : field.minValue"
          [max]="field.maxValue == null ? undefined : field.maxValue"
          [style.position]="fixedPos ? 'absolute' : undefined"
          [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
          [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
          [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
          [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
          [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 'px'} : undefined"
          [(ngModel)]="field.value"
          (ngModelChange)="valueChanged()"
          >
        </p-inputNumber>
      }
      @case(_FrontendFieldType.rating) {
        <p-rating #componentRating
          [class.ng-invalid]="errorMessage != null"
          [class.ng-dirty]="errorMessage != null"
          [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
          [tooltipStyleClass]="field.tooltipStyleClasses"
          [name]="field.id"
          [disabled]="!field.enabled"
          [stars]="field.maxValue >= 0 ? field.maxValue : 5"
          [style.position]="fixedPos ? 'absolute' : undefined"
          [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
          [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
          [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
          [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
          [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 'px'} : undefined"
          [(ngModel)]="field.value"
          (change)="valueChanged()"
          >
        </p-rating>
      }
      @case(_FrontendFieldType.maskField) {
        <p-inputMask #componentInputMask
          [class.ng-invalid]="errorMessage != null"
          [class.ng-dirty]="errorMessage != null"
          [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
          [tooltipStyleClass]="field.tooltipStyleClasses"
          [mask]="field.regexMask"
          [maxlength]="field.maxLength ?? 255"
          [attr.placeholder]="field.getPlaceholder()"
          [disabled]="!field.enabled"
          [style.text-transform]="field.upperCase ? 'uppercase' : null"
          [style.position]="fixedPos ? 'absolute' : undefined"
          [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
          [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
          [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
          [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
          [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 'px'} : undefined"
          [(ngModel)]="field.value"
          (onComplete)="valueChanged()"
          >
        </p-inputMask>
      }
      @case(_FrontendFieldType.dropdownMulti) {
        @if (!field.dropdownAutoComplete) {
          <p-multiSelect #componentMultiSelect
            [class.ng-invalid]="errorMessage != null"
            [class.ng-dirty]="errorMessage != null"
            [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
            [tooltipStyleClass]="field.tooltipStyleClasses"
            [options]="field.listItems"
            appendTo="body"
            [attr.placeholder]="field.getPlaceholder() ?? 'Keine Auswahl'"
            [disabled]="!field.enabled"
            [style.text-transform]="field.upperCase ? 'uppercase' : null"
            [style.position]="fixedPos ? 'absolute' : undefined"
            [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
            [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
            [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
            [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
            [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 1 + 'px'} : undefined"
            [(ngModel)]="field.value"
            (onChange)="valueChanged()"
            >
          </p-multiSelect>
        }
        @if (field.dropdownAutoComplete) {
          <p-autoComplete #componentAutoComplete
            [class.ng-invalid]="errorMessage != null"
            [class.ng-dirty]="errorMessage != null"
            [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
            [tooltipStyleClass]="field.tooltipStyleClasses"
            [suggestions]="autoCompleteSuggestions"
            [dropdown]="field.dropdownButtonVisible"
            field="label"
            dataKey="value"
            appendTo="body"
            [attr.placeholder]="field.getPlaceholder() ?? 'Keine Auswahl'"
            [disabled]="!field.enabled"
            [multiple]=true
            [style.text-transform]="field.upperCase ? 'uppercase' : null"
            [style.position]="fixedPos ? 'absolute' : undefined"
            [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
            [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
            [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
            [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
            [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 1 + 'px'} : undefined"
            [(ngModel)]="field.value"
            (completeMethod)="autoComplete($event)"
            (onChange)="valueChanged()"
            >
            <ng-template let-item pTemplate="item">
              <span [class.word-wrap]="field.dropdownWordWrap" [innerHTML]="_Strings.def(item.html ? ((item.labelInDropdown ?? item.label) | keepHtml) : item.labelInDropdown ?? item.label, '\u00A0')">
              </span>
            </ng-template>
          </p-autoComplete>
        }
      }
      @case(_FrontendFieldType.dropdown) {
        @if (!field.dropdownAutoComplete) {
          <p-select #componentSelect
            [class.ng-invalid]="errorMessage != null"
            [class.ng-dirty]="errorMessage != null"
            [class.width100pImportant]="!fixedPos"
            [class.height100p]="fullHeight"
            [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
            [tooltipStyleClass]="field.tooltipStyleClasses"
            [options]="field.listItems"
            [optionLabel]="field.dropdownOptionLabel"
            [maxlength]="field.maxLength ?? 65535"
            optionValue="value"
            appendTo="body"
            [attr.placeholder]="field.getPlaceholder() ?? 'Keine Auswahl'"
            [disabled]="!field.enabled"
            [editable]="field.dropdownEditable"
            [filter]="field.dropdownCanFilter"
            [filterBy]="field.dropdownFilterBy"
            [autoOptionFocus]=true
            [style.text-transform]="field.upperCase ? 'uppercase' : null"
            [style.position]="fixedPos ? 'absolute' : undefined"
            [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
            [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
            [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
            [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
            [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 1 + 'px'} : undefined"
            [(ngModel)]="field.value"
            (onChange)="valueChanged()"
            [attr.placeholder]="'\u00A0'"
            >
            @if (!field.dropdownEditable; as item) {
              <ng-template let-item pTemplate="selectedItem">
                {{_Strings.def(item?.label, '\u00A0')}}
              </ng-template>
            }
            <ng-template let-item pTemplate="item">
              <span [class.word-wrap]="field.dropdownWordWrap" [innerHTML]="_Strings.def(item.html ? ((item.labelInDropdown ?? item.label) | keepHtml) : item.labelInDropdown ?? item.label, '\u00A0')">
              </span>
            </ng-template>
          </p-select>
        }
        @else {
          <p-autoComplete #componentAutoComplete
            [class.ng-invalid]="errorMessage != null"
            [class.ng-dirty]="errorMessage != null"
            [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
            [tooltipStyleClass]="field.tooltipStyleClasses"
            [suggestions]="autoCompleteSuggestions"
            [dropdown]="field.dropdownButtonVisible"
            [optionLabel]="field.dropdownOptionLabel"
            [maxlength]="field.maxLength ?? 65535"
            dataKey="value"
            [optionValue]="identity"
            appendTo="body"
            [attr.placeholder]="field.getPlaceholder() ?? 'Keine Auswahl'"
            [disabled]="!field.enabled"
            [forceSelection]="!field.dropdownEditable"
            [style.text-transform]="field.upperCase ? 'uppercase' : null"
            [style.position]="fixedPos ? 'absolute' : undefined"
            [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
            [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
            [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
            [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
            [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 1 + 'px'} : undefined"
            [(ngModel)]="field.value"
            (completeMethod)="autoComplete($event)"
            (ngModelChange)="valueChanged()"
            >
            <ng-template let-item pTemplate="item">
              <span [class.word-wrap]="field.dropdownWordWrap" [innerHTML]="_Strings.def(item.html ? ((item.labelInDropdown ?? item.label) | keepHtml) : item.labelInDropdown ?? item.label, '\u00A0')">
              </span>
            </ng-template>
          </p-autoComplete>
        }
      }
      @case(_FrontendFieldType.dropdownCascade) {
        <p-cascadeSelect #componentCascadeSelect
          [class.ng-invalid]="errorMessage != null"
          [class.ng-dirty]="errorMessage != null"
          [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
          [tooltipStyleClass]="field.tooltipStyleClasses"
          [disabled]="!field.enabled"
          [name]="field.id"
          [optionLabel]="field.dropdownOptionLabel"
          optionGroupLabel="label"
          appendTo="body"
          optionGroupChildren="children"
          [attr.placeholder]="field.getPlaceholder() ?? 'Keine Auswahl'"
          [style.text-transform]="field.upperCase ? 'uppercase' : null"
          [style.position]="fixedPos ? 'absolute' : undefined"
          [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
          [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
          [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
          [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
          [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 1 + 'px'} : undefined"
          [(ngModel)]="field.value"
          (onChange)="valueChanged()"
          >
        </p-cascadeSelect>
      }
      @case(_FrontendFieldType.listBox) {
        <p-listbox #componentListBox
          class="full-height"
          [class.ng-invalid]="errorMessage != null"
          [class.ng-dirty]="errorMessage != null"
          [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
          [tooltipStyleClass]="field.tooltipStyleClasses"
          [options]="field.listItems"
          [optionLabel]="field.dropdownOptionLabel"
          optionValue="value"
          [disabled]="!field.enabled"
          [checkbox]="field.listBoxCheckBoxes"
          [multiple]="field.listBoxCheckBoxes"
          [filter]="field.dropdownCanFilter"
          [style.text-transform]="field.upperCase ? 'uppercase' : null"
          [style.position]="fixedPos ? 'absolute' : undefined"
          [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
          [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
          [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
          [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
          [style]="{width: fluentWidth ?? '100%', height: field.fixedHeight || '200px'}"
          [(ngModel)]="field.value"
          (onChange)="valueChanged()"
          >
        </p-listbox>
      }
      @case(_FrontendFieldType.textArea) {
        <textarea #componentTextArea
          pTextarea
          spellcheck=false
          [class.ng-invalid]="errorMessage != null"
          [class.ng-dirty]="errorMessage != null"
          [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
          [tooltipStyleClass]="field.tooltipStyleClasses"
          [maxLength]="field.maxLength ?? 65535"
          [disabled]="!field.enabled"
          [style.text-transform]="field.upperCase ? 'uppercase' : null"
          [style.position]="fixedPos ? 'absolute' : undefined"
          [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
          [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
          [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
          [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
          [style.resize]="'none'"
          [style.font-family]="field.monospaced ? 'monospace' : undefined"
          [style]="{width: fluentWidth ?? '100%', height: field.fixedHeight || '200px'}"
          [(ngModel)]="field.value"
          (input)="valueChanged()"
          >
        </textarea>
      }
      @case(_FrontendFieldType.date) {
        @if (field.datePickerYear || field.datePickerMonth) {
          <p-date-picker #componentDatePicker
            dateFormat="dd.mm.yy"
            [class.ng-invalid]="errorMessage != null"
            [class.ng-dirty]="errorMessage != null"
            [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
            [tooltipStyleClass]="field.tooltipStyleClasses"
            [disabled]="!field.enabled"
            [style.position]="fixedPos ? 'absolute' : undefined"
            [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
            [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
            [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
            [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
            [inputStyle]="getStyle(fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 'px'} : {'width': '100%'})"
            [style]="{'width': fluentWidth ?? '100%'}"
            [showOnFocus]=false
            [showIcon]="field.enabled"
            [view]="field.datePickerYear ? 'year' : field.datePickerMonth ? 'month' : 'date'"
            [dateFormat]="field.datePickerYear ? 'yy' : field.datePickerMonth ? 'mm.yy' : null"
            [(ngModel)]="field.value"
            appendTo="body"
            [firstDayOfWeek]=1
            (onInput)="valueChanged()"
            (onClose)="valueChanged()"
            >
          </p-date-picker>
        }
        @else {
        <!-- Das müssen wir leider machen, weil wenn wir dateFormat = null/undefined übergeben, immer das englische Defaultformat verwendet wird -->
        <p-date-picker #componentDatePicker
          dateFormat="dd.mm.yy"
          [class.ng-invalid]="errorMessage != null"
          [class.ng-dirty]="errorMessage != null"
          [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
          [tooltipStyleClass]="field.tooltipStyleClasses"
          [disabled]="!field.enabled"
          [style.position]="fixedPos ? 'absolute' : undefined"
          [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
          [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
          [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
          [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
          [inputStyle]="getStyle(fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 'px'} : {'width': '100%'})"
          [style]="{'width': fluentWidth ?? '100%'}"
          [(ngModel)]="field.value"
          appendTo="body"
          [showOnFocus]=false
          [showIcon]=true
          [firstDayOfWeek]=1
          [showTime]=false
          (onInput)="valueChanged()"
          (onClose)="valueChanged()"
          >
        </p-date-picker>
      }
    }
    @case(_FrontendFieldType.dateTime) {
      <p-date-picker #componentDatePicker
        dateFormat="dd.mm.yy"
        [class.ng-invalid]="errorMessage != null"
        [class.ng-dirty]="errorMessage != null"
        [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
        [tooltipStyleClass]="field.tooltipStyleClasses"
        [disabled]="!field.enabled"
        [style.position]="fixedPos ? 'absolute' : undefined"
        [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
        [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
        [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
        [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
        [inputStyle]="getStyle(fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 'px'} : {'width': '100%'})"
        [style]="{'width': fluentWidth ?? '100%'}"
        [(ngModel)]="field.value"
        appendTo="body"
        [showOnFocus]=false
        [showIcon]=true
        [firstDayOfWeek]=1
        [showTime]=true
        (onInput)="valueChanged()"
        (onClose)="valueChanged()"
        >
      </p-date-picker>
    }
    @case(_FrontendFieldType.time) {
      <p-inputMask #componentInputMask
        [class.ng-invalid]="errorMessage != null"
        [class.ng-dirty]="errorMessage != null"
        [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
        [tooltipStyleClass]="field.tooltipStyleClasses"
        mask="99:99"
        [maxlength]=5
        [disabled]="!field.enabled"
        [style.position]="fixedPos ? 'absolute' : undefined"
        [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
        [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
        [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
        [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
        [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 'px'} : undefined"
        [(ngModel)]="internalTimeValue"
        (onComplete)="valueChanged()"
        >
      </p-inputMask>
    }
    @case(_FrontendFieldType.bool) {
      @if (field.checkBoxTriState) {
        <p-checkbox #componentCheckBox
          [class.ng-invalid]="errorMessage != null"
          [class.ng-dirty]="errorMessage != null"
          [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
          [tooltipStyleClass]="field.tooltipStyleClasses"
          [ngModel]="field.value === true"
          [binary]=true
          [indeterminate]="field.value === null"
          [appLabel]="field.caption"
          [disabled]="!field.enabled"
          [style.position]="fixedPos ? 'absolute' : undefined"
          [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
          [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
          [style.width.px]="fixedPos ? field.fixedControlBounds.width - 50 : undefined"
          [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
          (onInput)="valueChanged()"
          (onChange)="valueChanged()"
          >
        </p-checkbox>
      }
      @else {
      <p-checkbox #componentCheckBox
        [class.ng-invalid]="errorMessage != null"
        [class.ng-dirty]="errorMessage != null"
        [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
        [tooltipStyleClass]="field.tooltipStyleClasses"
        [binary]=true
        [(ngModel)]="field.value"
        [appLabel]="field.caption"
        [disabled]="!field.enabled"
        [style.position]="fixedPos ? 'absolute' : undefined"
        [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
        [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
        [style.width.px]="fixedPos ? field.fixedControlBounds.width - 50 : undefined"
        [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
        (onInput)="valueChanged()"
        (onChange)="valueChanged()"
        >
      </p-checkbox>
    }
  }
  @case(_FrontendFieldType.radioButton) {
    <p-radioButton #componentRadioButton
      [class.ng-invalid]="errorMessage != null"
      [class.ng-dirty]="errorMessage != null"
      [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
      [tooltipStyleClass]="field.tooltipStyleClasses"
      [(ngModel)]="(mainRadioButtonField ?? field).value"
      [appLabel]="field.caption"
      [name]="field.radioButtonGroup"
      [value]="field.radioButtonValue"
      [disabled]="!field.enabled"
      [style.position]="fixedPos ? 'absolute' : undefined"
      [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
      [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
      [style.width.px]="fixedPos ? field.fixedControlBounds.width - 50 : undefined"
      [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
      (ngModelChange)="valueChanged()"
      >
    </p-radioButton>
  }
  @case(_FrontendFieldType.color) {
    <ng-container>
      @if (field.predefinedColors == null) {
        <sm-color-editor #componentColorEditor
          [class.ng-invalid]="errorMessage != null"
          [class.ng-dirty]="errorMessage != null"
          [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
          [tooltipStyleClass]="field.tooltipStyleClasses"
          [(value)]="field.value"
          [style.position]="fixedPos ? 'absolute' : undefined"
          [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
          [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
          [style.width.px]="fixedPos ? field.fixedControlBounds.width - 50 : undefined"
          [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
          (valueChange)="valueChanged()"
          >
        </sm-color-editor>
      }
      @else {
        <ngx-colors ngx-colors-trigger [ngModel]="_Utils.toColorHexString(field.value)" [palette]="getColorPalette()" (input)="colorChanged($event)"></ngx-colors>
      }
    </ng-container>
  }
  @case(_FrontendFieldType.button) {
    <button #componentButton
      pButton
      class="width100p"
      [class.ng-invalid]="errorMessage != null"
      [class.ng-dirty]="errorMessage != null"
      [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
      [tooltipStyleClass]="field.tooltipStyleClasses"
      [label]="field.caption"
      [icon]="field.icon"
      [severity]="field.severity"
      [disabled]="!field.enabled"
      [style.position]="fixedPos ? 'absolute' : undefined"
      [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
      [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
      [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
      [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
      (click)="buttonClick($event)"
      >
    </button>
  }
  @case(_FrontendFieldType.buttonAsLink) {
    <a #componentButtonAsLink
      class="mouse-pointer"
      [class.ng-invalid]="errorMessage != null"
      [class.ng-dirty]="errorMessage != null"
      [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
      [tooltipStyleClass]="field.tooltipStyleClasses"
      [style.position]="fixedPos ? 'absolute' : undefined"
      [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
      [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
      [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
      [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
      (click)="buttonClick($event)"
      >
      {{field.caption}}
    </a>
  }
  @case(_FrontendFieldType.stringList) {
    <string-list-editor #componentAutoComplete
        [class.ng-invalid]="errorMessage != null"
        [class.ng-dirty]="errorMessage != null"
        [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
        [tooltipStyleClass]="field.tooltipStyleClasses"
        [disabled]="!field.enabled"
        [style.text-transform]="field.upperCase ? 'uppercase' : null"
        [style.position]="fixedPos ? 'absolute' : undefined"
        [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
        [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
        [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
        [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
        [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 1 + 'px'} : undefined"
        [(ngModel)]="field.value"
        (ngModelChange)="valueChanged()"
        >
    </string-list-editor>
  }
  @case(_FrontendFieldType.fileUpload) {
    <app-sm-file-upload #componentFileUpload
      [class.ng-invalid]="errorMessage != null"
      [class.ng-dirty]="errorMessage != null"
      [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
      [tooltipStyleClass]="field.tooltipStyleClasses"
      [(value)]="field.value"
      [style.position]="fixedPos ? 'absolute' : undefined"
      [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
      [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
      [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
      [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
      (onValueChanged)="valueChanged()"
      >
    </app-sm-file-upload>
  }
  @case(_FrontendFieldType.imageUpload) {
    <app-sm-image-upload #componentImageUpload
      [class.ng-invalid]="errorMessage != null"
      [class.ng-dirty]="errorMessage != null"
      [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
      [tooltipStyleClass]="field.tooltipStyleClasses"
      [(value)]="field.value"
      [style.position]="fixedPos ? 'absolute' : undefined"
      [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
      [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
      [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
      [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
      (onValueChanged)="valueChanged()"
      >
    </app-sm-image-upload>
  }
  @case(_FrontendFieldType.spinner) {
    <p-progressSpinner #componentSpinner
      [class.ng-invalid]="errorMessage != null"
      [class.ng-dirty]="errorMessage != null"
      [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
      [tooltipStyleClass]="field.tooltipStyleClasses"
      [style.position]="fixedPos ? 'absolute' : undefined"
      [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
      [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
      [style.width.px]=30
      [style.height.px]=30
      >
    </p-progressSpinner>
  }
  @case(_FrontendFieldType.table) {
 <!--     [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
      [tooltipStyleClass]="field.tooltipStyleClasses"
  --><sm-table #componentTable
      [class.ng-invalid]="errorMessage != null"
      [class.ng-dirty]="errorMessage != null"
      [readOnly]="!field.enabled"
      [disabled]="!field.enabled"
      [allowFilter]="field.tableFloatingFilter"
      [floatingFilter]="field.tableFloatingFilter"
      [allowAddRow]="field.tableCanAddRow"
      [allowRemoveRow]="field.tableCanRemoveRow"
      [allowRowDrag]="field.tableAllowRowDrag"
      [addRowOnTabInLastCell]="field.tableAddRowOnTabInLastCell"
      [performAddTableRow]="_addTableRow"
      [performSetTableRows]="_setTableRows"
      [mustRefresh]="_mustRefresh"
      [useColumnMenu]=false
      [compact]="field.tableCompact"
      [data]="tableData"
      [style.position]="fixedPos ? 'absolute' : undefined"
      [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
      [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
      [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
      [style.height]="fixedPos ? field.fixedControlBounds.height + 'px' : field.fixedHeight || '150px'"
      [style.background]="'lightgray'"
      (onRowSelect)="tableSelectRow($event)"
      (onRowRemoved)="removeTableRow($event)"
      (onEditInit)="tableEditInit()"
      (onCellValueChanged)="tableEditComplete()"
      [fullScreenRowEditor]="field.fullScreenRowEditorOnMobile"
      >
    </sm-table>
  }
  @case(_FrontendFieldType.pageControl) {
    <sm-tab-view #componentTabs
      class="tab-view-no-clip full-height"
      [class.ng-invalid]="errorMessage != null"
      [class.ng-dirty]="errorMessage != null"
      [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
      [tooltipStyleClass]="field.tooltipStyleClasses"
      [style.position]="fixedPos ? 'absolute' : undefined"
      [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
      [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
      [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
      [style.height]="fixedPos ? field.fixedControlBounds.height + 'px' : field.fixedHeight || '150px'"
      [style.background]="'lightgray'"
      [(value)]="field.pageSelected"
      >
    @for (page of field.children; track page; let i = $index) {
        <sm-tab [header]="page.caption" class="overflow-y-clip">
            <app-sm-form-group [form]="form" [fields]="pageChildren[i]"></app-sm-form-group>
        </sm-tab>
    }
    </sm-tab-view>
  }
  @case(_FrontendFieldType.splitter) {
    <div class="divider"></div>
  }
}
}
<ng-template [insertionPoint]></ng-template>
